import React from 'react';
import { Box } from '../../base/Box/Box';
import { MacroDirectorySectionStoryblok } from '../../types/storyblok';
import MacroDirectoryCard from './components/MacroDirectoryCard/MacroDirectoryCard';
import { FinalButton } from './components/FinalButton/FinalButton';

export const MacroDirectorySection = ({
  cards,
  colourScheme = 'white',
  overlayOverBkg,
  finalButton,
}: MacroDirectorySectionStoryblok) => {
  if (!cards) {
    return null;
  }

  const hasFinalButton = !!finalButton && !!finalButton.length;

  return (
    <Box
      as="section"
      colourScheme={colourScheme || 'white'}
      blockSpacing
      bkg
      overlayOverBkg={overlayOverBkg}
    >
      <Box as="div" className="mx-auto flex max-w-wide flex-col">
        {cards?.map((card) => (
          <MacroDirectoryCard {...card} colourScheme={colourScheme} />
        ))}
        {hasFinalButton && <FinalButton button={finalButton[0]} />}
      </Box>
    </Box>
  );
};

export default MacroDirectorySection;
